export default "__VITE_ASSET__3e967bdb__"